import Animation from './Animation';
import '../Illustration/illustration.scss';
export default Animation;
